<accredible-base-header *transloco="let t; lang: 'en|static' read: 'certified_openlearning_com.header'">
  <div class="header-logo-container"
    identitySection>
    <img
      [alt]="t('issuer_logo')"
      class="branding-logo"
      src="/assets/themes/certified.openlearning.com/images/header_logo.png">
  </div>

  <div navigationSection>
    <sl-header-menu *ngIf="extraLinksLoaded"
      [extraDynamicMenuItems]="extraHeaderLinks">
    </sl-header-menu>
  </div>
</accredible-base-header>
